export default "__VITE_ASSET__5SG2x2Kc__"